var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-node"},[_c('g',{staticStyle:{"visibility":"visible"},attrs:{"transform":"translate(0.5,0.5)"}},[_c('polygon',{attrs:{"points":"6.16,0 21.84,0 28,14 21.84,28 6.16,28 0,14","fill":"#ffffff","stroke":"#000000","stroke-width":"1.3","pointer-events":"all"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }